const l = {
  name: "DevTools",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,5.9v6.4l1,0.5l1-0.5V5.9l1.3,0.5C25.1,7.4,27,10,27,13c0,2.8-1.6,5.2-4,6.3V31c0,1.7-1.3,3-3,3
			s-3-1.3-3-3V19.3c-2.4-1.1-4-3.5-4-6.3c0-3,1.9-5.6,4.7-6.6L19,5.9z M17,9c-1.2,0.9-2,2.4-2,4c0,2.2,1.4,4,3.3,4.7l0.7,0.2V31
			c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1V17.9l0.7-0.2C23.6,17,25,15.2,25,13c0-1.6-0.8-3.1-2-4v4.6l-3,1.5l-3-1.5V9z"/>
		<path class="st0" d="M9.7,16.7L6.4,20l3.3,3.3l-1.4,1.4L3.6,20l4.7-4.7L9.7,16.7z"/>
		<path class="st0" d="M30.3,16.7l3.3,3.3l-3.3,3.3l1.4,1.4l4.7-4.7l-4.7-4.7L30.3,16.7z"/>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v30c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5c0-1.7,1.3-3,3-3h30
			c1.7,0,3,1.3,3,3v30c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V5z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as DevTools
};
